import { render, staticRenderFns } from "./DeductionHistoryDialog.vue?vue&type=template&id=3a044f94"
import script from "./DeductionHistoryDialog.vue?vue&type=script&lang=js"
export * from "./DeductionHistoryDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports